<template>
  <div class="text-center">
    <v-dialog v-model="shower" max-width="1500" persistent>
      <v-card color="#525659" class="rounded-lg" max-height="1600">
        <v-card-title class="jusify-center" style="background-color: #ddf7ff">
          <v-btn color="#077893" fab x-small dark @click="fn_close()">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <div class="ml-3">
            {{ _detail.FileName }}
          </div>
          <v-spacer></v-spacer>
          <v-btn rounded color="#077893" dark @click="fn_downloadPdf">
            <v-icon>mdi-download</v-icon>
            <span v-if="$t('default') === 'th'">ดาวน์โหลดเอกสาร</span>
            <span v-else>Download</span>
          </v-btn>
          <!-- <v-btn color="error" fab x-small dark @click="fn_close()">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        </v-card-title>
        <v-card-text class="black--text text-center pa-0 ma-0">
          <div id="pdf-viewer">
            <iframe
              ref="pdfFrame"
              allowfullscreen
              :src="
                'data:' +
                _detail.FileType +
                ';base64,' +
                _detail.Base64 +
                '#toolbar=0&navpanes=0&scrollbar=0'
              "
            ></iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["show", "_detail"],
  data: function () {
    return {};
  },
  created() {},
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialog");
        }
      },
    },
  },
  watch: {},
  methods: {
    fn_close() {
      this.$emit("closeDialog");
      // window.location.reload();
    },
    fn_downloadPdf() {
      const iframe = this.$refs.pdfFrame; // เข้าถึงองค์ประกอบ iframe ด้วย $refs
      const pdfUrl = iframe.getAttribute("src"); // ดึงค่า URL ของ PDF จาก iframe
      const fileName = `${this._detail.FileName}`; // กำหนดชื่อไฟล์ที่ต้องการ

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = fileName;
      link.click();
    },
  },
};
</script>
<style scoped>
#pdf-viewer {
  width: 100%;
  height: 100%;
}
html,
body,
embed,
iframe,
object {
  margin: 0 !important;
  border: 0;
  width: 100%;
  height: 80vh;
}
</style>
